import * as jsonpatch from 'fast-json-patch';
import { deleteRequest, patchRequest, postRequest } from '../../../core/utils/api';
import { type KeycloakContext } from '../../authentication/keycloak/KeycloakProvider';
import Announcement from '../models/announcement';
import showStatusCodeError from './logging.service';

export const createAnnouncement = async (announcement: Announcement, keycloak: KeycloakContext): Promise<Announcement | undefined> => {
  const apiResponse = await postRequest<Announcement>('office-announcement', keycloak, announcement);

  if (apiResponse.error) {
    showStatusCodeError(apiResponse.status);
    return undefined;
  }

  return JSON.parse(JSON.stringify(apiResponse.json));
};

export const updateAnnouncement = async (
  originalAnnouncement: Announcement,
  changedAnnouncement: Announcement,
  keycloak: KeycloakContext,
): Promise<Announcement | undefined> => {
  if (originalAnnouncement.id === undefined) {
    return undefined;
  }

  const apiResponse = await patchRequest<Announcement>(
    `office-announcement/${originalAnnouncement.id}`,
    keycloak,
    jsonpatch.compare(originalAnnouncement, changedAnnouncement),
  );

  if (apiResponse.error) {
    return undefined;
  }
  return apiResponse.json;
};

export const deleteAnnouncement = async (announcement: Announcement, keycloak: KeycloakContext): Promise<boolean> => {
  if (announcement.id === undefined) {
    return false;
  }

  const apiResponse = await deleteRequest(`office-announcement/${announcement.id}`, keycloak);

  if (apiResponse.error) {
    return false;
  }
  return true;
};
